import React, { useRef, useState } from 'react';
import Section from '../components/Section';
import TextField from '../components/TextField';

const MAX_PHOTO_BYTES = 5 * 1024 * 1024; // 5 MB
const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

function S8_Other({ data, onChange, errors, photoFile, onPhotoChange }) {
  const fileInputRef = useRef(null);
  const [photoError, setPhotoError] = useState('');

  function handleFileChange(e) {
    const file = e.target.files && e.target.files[0];
    setPhotoError('');
    if (!file) { onPhotoChange(null); return; }
    if (!ACCEPTED_TYPES.includes(file.type)) {
      setPhotoError('Only JPG, PNG, or WebP images are accepted.');
      e.target.value = '';
      onPhotoChange(null);
      return;
    }
    if (file.size > MAX_PHOTO_BYTES) {
      setPhotoError('Photo must be under 5 MB.');
      e.target.value = '';
      onPhotoChange(null);
      return;
    }
    onPhotoChange(file);
  }

  function handleRemove() {
    setPhotoError('');
    onPhotoChange(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  }

  const previewUrl = photoFile ? URL.createObjectURL(photoFile) : null;

  return (
    <Section title="Anything else?">

      {/* NEW — Voids / Refunds toggle */}
      <div className="field-group">
        <label className="field-label">
          Any voids or refunds today?
        </label>
        <div className="toggle-row">
          <button
            type="button"
            className={`toggle-btn${data.voids_today ? '' : ' toggle-btn-active'}`}
            onClick={() => {
              onChange('voids_today', false);
              onChange('voids_detail', '');
            }}
          >
            No
          </button>
          <button
            type="button"
            className={`toggle-btn${data.voids_today ? ' toggle-btn-active' : ''}`}
            onClick={() => onChange('voids_today', true)}
          >
            Yes
          </button>
        </div>
      </div>

      {/* Conditional — voids detail (required if voids_today = true) */}
      {data.voids_today && (
        <TextField
          label="How many, and why?"
          value={data.voids_detail || ''}
          onChange={(v) => onChange('voids_detail', v)}
          multiline
          maxLength={300}
          required
          hasError={!!errors.voids_detail}
          errorMsg={errors.voids_detail}
          placeholder="e.g. 2 voids — one wrong order, one customer changed mind after payment"
        />
      )}

      {/* Existing — other notes */}
      <TextField
        label="Anything else worth flagging today?"
        value={data.other_notes || ''}
        onChange={(v) => onChange('other_notes', v)}
        multiline
        maxLength={300}
        placeholder="Optional — anything not covered above"
      />

      {/* NEW — One thing that would have made today better (mandatory) */}
      <TextField
        label="What's one thing that would have made today better? (staff, equipment, menu, anything)"
        value={data.one_thing_better || ''}
        onChange={(v) => onChange('one_thing_better', v)}
        multiline
        maxLength={400}
        required
        hasError={!!errors.one_thing_better}
        errorMsg={errors.one_thing_better}
        placeholder="e.g. The bar printer jammed twice during rush hour and slowed us down"
      />

      {/* Existing — Photo upload */}
      <div className="field-group">
        <label className="field-label">
          Add a photo (optional)
        </label>
        <p className="field-hint" style={{ marginBottom: '10px' }}>
          e.g. equipment issue, hygiene concern — JPG, PNG or WebP, max 5 MB
        </p>

        {!photoFile ? (
          <label className="photo-upload-label">
            <input
              ref={fileInputRef}
              type="file"
              accept="image/jpeg,image/png,image/webp"
              onChange={handleFileChange}
              className="photo-upload-input"
              aria-label="Upload a photo"
            />
            <span className="photo-upload-btn">
              📷 Choose photo
            </span>
          </label>
        ) : (
          <div className="photo-preview-wrap">
            <img
              src={previewUrl}
              alt="Attached file preview"
              className="photo-preview-img"
            />
            <div className="photo-preview-meta">
              <span className="photo-preview-name">{photoFile.name}</span>
              <button
                type="button"
                className="photo-remove-btn"
                onClick={handleRemove}
                aria-label="Remove photo"
              >
                Remove
              </button>
            </div>
          </div>
        )}

        {photoError && (
          <p className="error-message" style={{ marginTop: '8px' }}>
            {photoError}
          </p>
        )}
      </div>
    </Section>
  );
}

export default S8_Other;
